import firebase from 'firebase/app'
import { ulid } from 'ulid'

/**
 * ドキュメントを新規作成して保存
 * @param {{ db: firebase.firestore.Firestore, path: string, date: string, data: object }}
 * @returns {Promise<string>} 作成されたドキュメントのID
 * @note date は yyyy-mm-dd 形式文字列
 */
export const create = async ({ db, path, date, data }) => {
  // コレクション リファレンスに新規ドキュメントを作成
  const id = `${date}_${ulid()}`
  await db
    .collection(path)
    .doc(id)
    .set({
      ...data,
      date, // BigQuery パーティショニング用に日付を追加
      createAt: firebase.firestore.FieldValue.serverTimestamp(),
    })

  return id
}

/**
 * 指定された日付の最新のドキュメントを取得
 * @param {{ db: firebase.firestore.Firestore, path: string, date: string }}
 * @returns {Promise<firebase.firestore.QueryDocumentSnapshot | null>} ドキュメントのスナップショット
 * @note date は yyyy-mm-dd 形式文字列
 */
export const fetch = async ({ db, path, date }) => {
  // コレクションから指定された日の最新の日報を取得
  const querySnapshot = await db
    .collection(path)
    .where(firebase.firestore.FieldPath.documentId(), '>=', `${date}_`)
    .where(firebase.firestore.FieldPath.documentId(), '<=', `${date}_\uf8ff`) // \uf8ffはUnicodeの終端文字
    .orderBy(firebase.firestore.FieldPath.documentId(), 'desc') // 最新順に並べる
    .limit(1)
    .get()

  // ドキュメントの存在を確認
  if (querySnapshot.empty) return

  // 選択した日付のドキュメントを返す
  return querySnapshot.docs[0]
}
